module.exports = __webpack_public_path__ + "static/banner.intro-dcb4b02e6c6a106233837ae580b2f694.png";